"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNftRewardResponseToJSON = exports.GetNftRewardResponseFromJSONTyped = exports.GetNftRewardResponseFromJSON = void 0;
var _1 = require("./");
function GetNftRewardResponseFromJSON(json) {
    return GetNftRewardResponseFromJSONTyped(json, false);
}
exports.GetNftRewardResponseFromJSON = GetNftRewardResponseFromJSON;
function GetNftRewardResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nftReward': (0, _1.NftRewardMetadataFromJSON)(json['nftReward']),
        'prizes': (json['prizes'].map(_1.NftRewardPrizeFromJSON)),
    };
}
exports.GetNftRewardResponseFromJSONTyped = GetNftRewardResponseFromJSONTyped;
function GetNftRewardResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nftReward': (0, _1.NftRewardMetadataToJSON)(value.nftReward),
        'prizes': (value.prizes.map(_1.NftRewardPrizeToJSON)),
    };
}
exports.GetNftRewardResponseToJSON = GetNftRewardResponseToJSON;
